import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, Plus, DoorOpen, User, Notebook } from 'lucide-react';

export default function BottomNav() {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/discover', icon: Compass, label: 'Discover' },
    { path: '/checkins', icon: Plus, label: 'Check-ins' },
    // Sessions feature
    { path: '/sessions', icon: Notebook, label: 'Sessions' },
    { path: '/cellar', icon: DoorOpen, label: 'My Cellar' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#0b0b0b',
      borderTop: '1px solid #1f1f1f',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.2rem',
      padding: '1rem 0 0.6rem', // Preserve nav height after removing legal line
      paddingBottom: 'max(0.6rem, env(safe-area-inset-bottom, 0px))',
      zIndex: 1001, // Higher than map overlays to ensure always visible
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.25rem',
                textDecoration: 'none',
                color: isActive ? '#ff9500' : '#ffffff',
                flex: 1,
              }}
            >
              <Icon size={24} color={isActive ? 'var(--color-accent)' : '#ffffff'} />
              <span style={{ fontSize: '0.75rem', fontWeight: isActive ? '600' : '400' }}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

